import { render, staticRenderFns } from "./PricesGridRow.vue?vue&type=template&id=5d839b2e&"
import script from "./PricesGridRow.vue?vue&type=script&lang=js&"
export * from "./PricesGridRow.vue?vue&type=script&lang=js&"
import style0 from "./PricesGridRow.vue?vue&type=style&index=0&id=5d839b2e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports